import { USER_URL } from "../constant/api";

// all brands fetch api
export const BrandFetchApi = async () => {
  try {
    const response = await USER_URL.get("products/brand/");
    return response.data;
  } catch (error) {
    console.log("Error in add product", error);
    throw error;
  }
};

// seller based brand fetch api
export const SellerBrandFetchApi = async (id) => {
  try {
    const response = await USER_URL.get(`/products/nearest-supplier/${id}/brands/`);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("Error in fetching seller based brand", error);
    throw error;
  }
};